import { Bar, BarChart, CartesianGrid, LabelList, XAxis, YAxis } from "recharts"
import {
    Card,
    CardContent,
    CardHeader,
    CardTitle,
} from "@/components/ui/card"
import {
    ChartConfig,
    ChartContainer,
    ChartTooltip,
    ChartTooltipContent,
} from "@/components/ui/chart"
import { useEffect, useState } from "react"
import axiosInstance from "@/utils/axiosInstance"

const chartConfig = {
    driverName: {
        label: "Driver",
        color: "hsl(var(--chart-1))",
    },
    orders: {
        label: "Orders",
        color: "hsl(var(--chart-2))",
    }
} satisfies ChartConfig

const DriverCompletedOrdersChart = ({ range }: { range: { startDate: Date, endDate: Date } }) => {

    const [chartData, setChartData] = useState([])

    useEffect(() => {

        const fetchData = async () => {
            try {

                const res = await axiosInstance.get(`/reports/driver-completed-orders`, {
                    params: {
                        startDate: range.startDate.toISOString().split("T")[0],
                        endDate: range.endDate.toISOString().split("T")[0],
                    }
                })


                setChartData(res.data);

            } catch (error) {
                console.error("Gabim gjatë marrjes së të dhënave:", error)
            }
        }

        fetchData();

    }, [range])

    return (
        <Card>
            <CardHeader>
                <CardTitle>Drivers by completed orders</CardTitle>
            </CardHeader>
            <CardContent>
                <ChartContainer config={chartConfig}>
                    <BarChart
                        accessibilityLayer
                        data={chartData}
                        layout="vertical"
                        margin={{
                            right: 16,
                        }}
                    >
                        <CartesianGrid horizontal={false} />
                        <YAxis
                            dataKey="driverName"
                            type="category"
                            tickLine={false}
                            tickMargin={10}
                            axisLine={false}
                            tickFormatter={(value) => value.slice(0, 3)}
                            hide
                        />
                        <XAxis dataKey="orders" type="number" hide />
                        <ChartTooltip
                            cursor={false}
                            content={<ChartTooltipContent indicator="line" />}
                        />
                        <Bar
                            dataKey="orders"
                            layout="vertical"
                            fill="var(--color-chart-dark-green)"
                            radius={4}
                        >
                            <LabelList
                                dataKey="driverName"
                                position="insideLeft"
                                offset={8}
                                className="fill-[--color-label]"
                                fontSize={12}
                            />
                            <LabelList
                                dataKey="orders"
                                position="right"
                                offset={8}
                                className="fill-foreground"
                                fontSize={12}
                            />
                        </Bar>
                    </BarChart>
                </ChartContainer>
            </CardContent>
        </Card>
    )

}

export default DriverCompletedOrdersChart;